import * as React from 'react';
import {LinkPracticeScreenType} from '@practicegenius/register-account/src/screens/LinkPractice';
import {Input} from '@practicegenius/pg-ui/src/base/Material/components/Input';
import {IMT} from '@practicegenius/pg-util/src/StringUtils';
import {RegistrationEvent} from '@practicegenius/register-account/src/machines/accountRegistration';
import {inMobileApp} from '@practicegenius/pg-ui/src/utils/MobileApp';
import {loginBottomText} from '../components/layout';
import {ProgressScreen} from '../../../components/screens/BaseScreen';
import {capitalize} from '../../../utils/string';
import ServiceBrand from '../../../utils/ServiceBrand';
import {usePhpJs} from '../../../utils/php-js';
import {LoginSupportFooter} from '../../../components/LoginSupportFooter';

export const LinkPractice: LinkPracticeScreenType = ({
  registrationMachine: machine,
  lang,
  isGenericHub,
  onFormSubmit,
  progress,
  actionButtons,
  cardNumberInputProps,
}) => {
  const [, send] = machine;
  const practice = usePhpJs(({practice: {practice_name}, practice_code}) => ({
    businessCode: practice_code,
    practiceName: practice_name,
  }));

  const instructions = isGenericHub ? (
    lang.instructions.generic
  ) : (
    <>
      {lang.instructions.default.top}
      <br />
      {IMT(lang.instructions.default.bottom, {
        practiceName: practice.practiceName ?? lang.defaultPracticeName,
      })}
    </>
  );

  return (
    <form onSubmit={onFormSubmit}>
      <ProgressScreen
        helmetTitle={IMT(lang.pageTitle, {
          practiceType: capitalize(ServiceBrand.lang.practiceNoun),
        })}
        headerTitle={lang.headerTitle}
        progress={progress}
        title={lang.title}
        instructions={instructions}
        actionButtons={[
          actionButtons.primary,
          {
            ...actionButtons.secondary,
            onClick: () => {
              if (isGenericHub || inMobileApp) {
                send(RegistrationEvent.GO_TO_GENERIC_REGISTRATION_WARNING);
                return;
              }

              send({
                type: RegistrationEvent.CONNECT_BUSINESS_CODE,
                businessCode: practice.businessCode,
              });
            },
            children: isGenericHub ? (
              <span>
                {lang.buttons.secondary.title.generic.top}
                <br />
                {lang.buttons.secondary.title.generic.bottom}
              </span>
            ) : (
              <>{lang.buttons.secondary.title.default}</>
            ),
          },
        ]}
        bottomText={
          <>
            {loginBottomText}
            <LoginSupportFooter />
          </>
        }
        cancelProps={{href: '/'}}
      >
        <Input
          type="text"
          name="cardNumber"
          value={cardNumberInputProps.value ?? ''}
          onChange={e => cardNumberInputProps.onChange(e.target.value)}
          label={lang.cardNumberInput.label}
          data-testid="cardNumber"
          error={cardNumberInputProps.error}
        />
      </ProgressScreen>
    </form>
  );
};
